// extracted by mini-css-extract-plugin
export default {"textarea-section":"Textarea_textarea-section__pCOgH","textarea-field":"Textarea_textarea-field__bd6vh"};